function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStackOverflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.001 21.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-1149.277 1662.916a10 10 0 0 0-10 10 10 10 0 0 0 10 10 10 10 0 0 0 10-10 10 10 0 0 0-10-10zm-1.428 7.052 4.3 2.536-.542.918-4.3-2.536zm-1.15 2.46 4.821 1.3-.277 1.03-4.821-1.3zm-.478 2.229 4.971.458-.1 1.062-4.971-.458zm4.851 1.825v1.066h-4.993v-1.066zm1.7 2.505s0 .249-.008.249h-8.245v-5.2h.853v4.359h6.548v-4.359h.853zm-.45-6.63-2.813-4.125.881-.6 2.813 4.125zm1.072-.665-.854-4.919 1.051-.182.854 4.919z",
    transform: "translate(1159.778 -1662.416)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackOverflow);
export default __webpack_public_path__ + "static/media/stack_overflow.0970a594.svg";
export { ForwardRef as ReactComponent };